export function getFooterColumnsWidths(columnWidths, visibleBusinessDetails, visibleSocialIcons, visibleSiteTitle) {
    var socialColumnWidth = visibleSocialIcons && visibleBusinessDetails
        ? columnWidths[1]
        : columnWidths[0];
    var businessColumnWidth = visibleBusinessDetails && columnWidths[0];
    var titleWidth = visibleSiteTitle && columnWidths[columnWidths.length - 1];
    return {
        socialColumnWidth: (socialColumnWidth && socialColumnWidth + "%") || undefined,
        businessColumnWidth: (businessColumnWidth && businessColumnWidth + "%") || undefined,
        titleWidth: (titleWidth && titleWidth + "%") || undefined,
    };
}
//# sourceMappingURL=footer-utils.js.map